module.exports = __webpack_public_path__ + "files/936e362716c70ad25b10531d4e334942.png";